<template>
  <div class="rounded-xl min-w-[340px] max-w-[402px] min-h-[381px] h-full">
    <div
      :class="[
      'relative rounded-xl text-white overflow-hidden dark:shadow-none h-full flex flex-col',
      noShadow
        ? 'shadow-none'
        : 'shadow-[5px_5px_39.7px_3px_rgba(0,0,0,0.14)]',
    ]">
      <NuxtImg class="rounded-t-xl" :alt="content.heading" :src="content.image" height="260" width="402" loading="eager"
        format="webp" />
      <div class="pb-px pl-px pr-px bg-[image:var(--border-case-studies-cards)] rounded-b-xl grow">
        <div
          class="h-full rounded-b-xl px-6 py-4 bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] dark:bg-[rgba(27,2,43,1)]">
          <NuxtLink :to="content.links" class="text-lg font-semibold !tracking-[0.5px] pb-2">
            {{ content.heading }}
            <span class="absolute inset-0"></span>
          </NuxtLink>
          <p class="text-sm !tracking-[0.5px]" v-html="content.text"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type ProjectCardContent = {
  // companyIcon: string;
  heading: string;
  image: string;
  text?: string;
  links: string;
};

const props = withDefaults(
  defineProps<{
    content: ProjectCardContent;
    noShadow?: boolean;
  }>(),
  {
    content: () => ({
      heading: "Horse Racecourse<br /> Management",
      image: "/images/equetronicCardImage.webp",
      links: "/case-studies/toolstation",
    }),
    noShadow: false,
  }
);
</script>
